<template>
  <div class="customer-review">
  
    <employee-dialog v-model="employeeDialogMain" @select="setReviewApprove"></employee-dialog>
    <index-view title="Danh sách nhân viên" :filters="filters" :getData="getData" :getDetail="getDetail" :headers="mainHeaders" 
    :detailWidth="1000" :cellSlots="cellSlots" tableKey="code">
      
      <template #action2="{ item, reload }" >
        <v-switch v-model="hasQuit" @change="reload" label="Bao gồm nghỉ việc" color="green"></v-switch>
      </template>

      <template #viewSection="{ item, selected }" >
        <detail :item="item" :selected="selected"></detail>
      </template>
        
        
      <template v-slot:[`status`]="{ cell, reload }">
        <v-chip small label :color="cell.status == 'Hoạt Động' ? 'green lighten-5' : 'red lighten-5'" style="width: 120px;"> 
          <v-icon left :color="cell.status == 'Hoạt Động' ? 'green' : 'red'">mdi-circle-small</v-icon>
          <span :class="'text-caption font-weight-bold ' +  (cell.status == 'Hoạt Động' ? 'green--text text--darken-2' : 'red--text text--darken-2')">{{ cell.status }}</span>
        </v-chip>
      </template>

      <template v-slot:[`birthDay`]="{ cell, reload }">
        <span class="text-caption">{{ cell.birthDay }}</span>
      </template>
      
      <template v-slot:[`hireDate`]="{ cell, reload }">
        <span class="text-caption">{{ cell.hireDate }}</span>
      </template>

      <template v-slot:[`storeName`]="{ cell, reload }">
        <span class="font-weight-medium">{{ cell.storeName }}</span>
        <p class="text-caption">Mã Store: {{ cell.storeAlias }}</p>
      </template>
      
      <template v-slot:[`positionStateName`]="{ cell, reload }">
        <span class="font-weight-medium">{{ cell.positionStateName }}</span>
      </template>
      
      <template v-slot:[`gender`]="{ cell, reload }">
        <v-icon small color="blue" v-if="cell.gender == true">mdi-gender-male</v-icon>
        <v-icon small color="pink" v-if="cell.gender == false">mdi-gender-female</v-icon>
        <!-- <b class="blue--text text-darken--4" v-if="cell.gender == true">Nam</b>
        <b class="pink--text text-darken--4" v-if="cell.gender == false">Nữ</b> -->
      </template>
      
      <template v-slot:[`code`]="{ cell, reload }">
        <span class="font-weight-medium">{{ cell.code }}</span>
      </template>
      

      <template v-slot:[`name`]="{ cell, reload }">
        <v-avatar class="mr-2 my-1"
          size="52px"
        >
          <img :src="cell.avatar" alt="" srcset="" >
        </v-avatar>
        <span class="font-weight-medium">{{ cell.name }}</span>
      </template>

    </index-view>
    
  </div>
</template>

<script>

import IndexView from '../../../components/CommonView/IndexView.vue';
import { get } from './js/rmApi'
import { main } from './js/rmHeader'
import EmployeeDialog from '../../../components/Crud/Prompt/EmployeeDialog.vue';
import moment from 'moment';
const statusFilters = ['Tạo mới', 'Hoàn tất', 'Hủy']
export default {
  name: "RmEmployee",
  components: {
    IndexView,
    // Detail,
    EmployeeDialog
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    },
    yearOptions() {
      let thisYear = moment().year();
      let lowerYear = thisYear - 5;
      let upperYear = thisYear + 5;
      var yearOptions = [];
      for(let y = lowerYear; y <= upperYear; y++) {
        yearOptions.push(y);
      }

      return yearOptions;
    }

  },
  data() {
    return {
      hasQuit: false,
      filters: [
        {name: 'code', label:'Mã NS', type: 'text', value: '' },
        {name: 'name', label:'Tên NS', type: 'text', value: '' },
        // {name: 'storeAlias', label:'Mã Store', type: 'text', value: '' },
        {name: 'storeName', label:'Tên Store', type: 'text', value: '' },
        {name: 'deptArea', label:'Vùng', type: 'text', value: '' },
        // {name: 'status', label:'Trạng thái', type: 'select', selectItems: statusFilters, value: '' },
      ],
      cellSlots: ['code', 'birthDay','hireDate', 'gender', 'name', 'storeName', 'positionStateName', 'status'],
      selected: null,
      action1Dialog: false,
      actionData: {
        month: null
      },
      finals: [],
      headers : main,
      sessionYear: moment().year(),

      action2Dialog: false,
      action2Calendar: null,
      readySearch: '',
      readies: [],
      // readyHeaders: readyHeaders,
      readyLoading: false,

      employeeDialog: false,
      employeeDialogMain: false,
    }
  },
  watch: {
    action2Calendar(newVal) {
      this.getReady();
    },
    sessionYear(newVal) {
      this.getFinalSession();
    }
  },
  methods: {
    getData() {
      return get(this.hasQuit)
    },
    // getDetail: getDetailByEmployee,
    actionSubmit(item) {
      return setFinal(item.month).then(() =>{
        // this.action1Dialog = false;
      }).finally(() => {
        this.getFinalSession();
      })
    },
    actionRemove(item) {
      return removeFinal(item.month).then(() => {
        this.finals = this.finals.filter(i => i.month !== item.month)
      }).finally(() => {
        this.getFinalSession();
      })
    },
    getFinal() {
      return getFinal().then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    getFinalSession() {
      return getFinalSession(this.sessionYear).then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    //ready section
    getReady() {
      this.readyLoading =true
      return getReady(this.action2Calendar).then(data => {
        this.readies = data.data;
      }).finally(() => {
        this.readyLoading =false
      })
    },
    
    setReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return setReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    setEmployee(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeConfirmedBy(this.selected.id, '').then(() => {
          this.selected.smCode = ''
          this.selected.smName = ''
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }else {
        return changeConfirmedBy(this.selected.id, empObj.code).then(() => {
          this.selected.smCode = empObj.code
          this.selected.smName = empObj.name
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    setReviewApprove(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeApprovedBy(this.selected.id, null).then(() => {
            this.selected.approvedByCode = null
            this.selected.approvedByName = null
            this.employeeDialogMain = false
          }).finally(() => {
            this.selected = null
          })
      }else {
        return changeApprovedBy(this.selected.id, empObj.code).then(() => {
          this.selected.approvedByCode = empObj.code
          this.selected.approvedByName = empObj.name
          this.employeeDialogMain = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    
    initReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return initReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },

    generateReview() {
      //call api to generate review for ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return generateReview(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    convertStatus(status) {
      if(status === 0) return {text:'Tạo mới', color:'cyan--text'}
      if(status === 1) return {text:'SM duyệt', color:'green--text'}
      if(status === 2) return {text:'Lưu trữ', color:'blue--text'}
      return {text:'Hủy', color:'red--text'}
    }
  },
  mounted() {
    // this.getFinal().then(d => {
    // });

    this.getFinalSession(2025)
  }
}
</script>